import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ServicesSectionThree = () => {


  const [items, setItems] = useState([]);
  const [service, setService] = useState([]);

  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/service-item-three`)
      .then((res) => res.json())
      .then((info) => setItems(info));
  }, []);


  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/service-three`)
      .then((res) => res.json())
      .then((info) => setService(info));
  }, []);


  return (




    <>  <section className="working-section centred  pb_120" id="services-sec">
      <div className="pattern-layer" style={{ backgroundImage: 'url(assets/images/shape/shape-4.png)' }} />
      <div className="auto-container">
        {
          service.map(a=><div className="sec-title mb_60">
            <span className="sub-title " >{a.serviceHeadingThree}</span>
            <h2>{a.servicesubHeadingThree}</h2>
          </div> )
        }
        
        <div className="inner-container">
          <div className="row clearfix">

            {
              items.map(e => <div className="col-lg-4 col-md-6 col-sm-12 working-block">
                <div className="working-block-one">
                  <div className="inner-box">
                    <div className="upper-box">
                      <div >
                      <img src={e.serviceIconThree} alt="Service Icon" style={{ width: '50px', height: '50px' }} />
                      <div className="lower-content">
                      <h3>{e.serviceTitleThree}</h3>
                      <p>{e.serviceDetailsThree}</p>
                    </div>

                      </div>
                    </div>
                   
                  </div>
                </div>
              </div>)
            }



          </div>
        </div>
      </div>
    </section>
    </>


  );
};

export default ServicesSectionThree;
